import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// eslint-disable-next-line react/prefer-stateless-function
class EmployeesLeftSidebar extends React.PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <h4>{t('employees.page_title')}</h4>
        <p>{t('employees.p1')}</p>
      </div>
    );
  }
}

export default withTranslation('common')(EmployeesLeftSidebar);
